// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import {
  GetSparseFulfillmentsOptions,
  getSparseFulfillments,
} from '@/fulfillment/api/get-sparse-fulfillments';
import { REFERENCE_DATA_QUERY_OPTIONS } from '@/utilities/query-profiles';
import { useQuery } from '@tanstack/react-query';

/**
 * A React hook that requests a lightweight collection of fulfillment orders from the remote API.
 * This hook is optimized for autocomplete components and dropdowns where only basic
 * fulfillment information is needed.
 */
export function useSparseFulfillmentList(
  options: GetSparseFulfillmentsOptions = {}
) {
  const { data, isLoading, isFetching } = useQuery({
    queryKey: ['sparse-fulfillments', options.statuses, options.ignore3pl],
    queryFn: () => getSparseFulfillments(options),
    ...REFERENCE_DATA_QUERY_OPTIONS,
  });

  return {
    fulfillments: data?.fulfillments ?? [],
    isLoading,
    isFetching,
  };
}
